export const CLOSE = 'Zamknij'
export const SEND_REPORT = 'Wyślij zgłoszenie'
export const SAVE = 'Wyślij zgłoszenie'
export const REPORT_SENT_SUCCESSFULLY = 'Zgłoszenie zostało pomyślnie wysłane!'
